var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { cx, css as emotionCss } from 'emotion';
import { getAutomation, getDebug, getStyleNames, useCitrusDebug, useRefState } from '@citrus/runtime';
import { useLocalization, useTheme } from '@citrus/user';
import { escapeKeyPressed, isNotNilOrEmpty, isNilOrEmpty, keyPressed, isString, iif, isNotNil } from '@pcty/utils';
import { getChildByType, getChildrenByTypeDeep, removeChildrenByTypeDeep, getChildByTypeDeep } from 'react-nanny';
import { Icon } from '@citrus/icon';
import { BorderlessButton } from '@citrus/button';
import { FlyoutContext } from './private/context';
import localizationMap from '../localization';
import { docked as dockedCss, closeButton, headerIcon } from '../styles/legacy';
import { closeButton as closeButtonCitron, flyoutMenuNoFooter } from '../styles/citron';
import { locations, defaultAutoUpdateOptions } from '../types';
import { isOwningElement } from '../utils/isOwningElement';
import { Flyout as XFlyout, FlyoutMenu, Arrow, Body as XBody, BodyHeader, BodyMenu, BodyUtility, FocusTrapRoot, FocusTrapInnerContainer, Menu as XMenu, MenuWithHeader, Wrapper, } from './Flyout.styled';
import Footer from './FlyoutFooter';
import Header from './FlyoutHeader';
import MenuItem from './FlyoutMenuItem';
import { computePosition, autoPlacement, flip, shift as shiftFn, offset, arrow as arrowFn, autoUpdate, } from '@floating-ui/dom';
import Trigger from './FlyoutTrigger';
import Content from './FlyoutContent';
import { v4 as newGuid } from 'uuid';
import { FocusScope } from '@react-aria/focus';
import FocusTrap from 'focus-trap-react';
/**
 * There is currently an open issue where the focus of the FlyoutMenu does not
 * return to the next tabbable item if a tabbable item does not exist after it.
 * Instead, the focus attaches to the body and goes to the first element on the page.
 * https://github.com/adobe/react-spectrum/issues/2444
 *
 * TODO: Check if fix has been provided or figure out workaround.
 */
var VERSION = '5.5.1';
var Flyout = function (_a) {
    var _b, _c;
    var ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"], _d = _a.arrow, arrow = _d === void 0 ? true : _d, arrowOffset = _a.arrowOffset, automationId = _a.automationId, autoUpdateOptions = _a.autoUpdateOptions, children = _a.children, className = _a.className, css = _a.css, cssWrapper = _a.cssWrapper, disableFocusTrap = _a.disableFocusTrap, disableRestoreFocus = _a.disableRestoreFocus, _e = _a.docked, docked = _e === void 0 ? false : _e, edgeSpacing = _a.edgeSpacing, fixed = _a.fixed, _f = _a.flipLocation, flipLocation = _f === void 0 ? true : _f, focusTrapProps = _a.focusTrapProps, _g = _a.showClose, showClose = _g === void 0 ? false : _g, id = _a.id, _h = _a.ignoreCancelActions, ignoreCancelActions = _h === void 0 ? false : _h, _j = _a.location, location = _j === void 0 ? 'bottom' : _j, onClose = _a.onClose, open = _a.open, _k = _a.portal, portal = _k === void 0 ? false : _k, _l = _a.preventScrollOnClose, preventScrollOnClose = _l === void 0 ? true : _l, _m = _a.removeBodyPadding, removeBodyPadding = _m === void 0 ? false : _m, _o = _a.shift, shift = _o === void 0 ? false : _o, externalStyleNames = _a.styleNames, _p = _a.__TYPE, TYPE = _p === void 0 ? 'Flyout' : _p, other = __rest(_a, ['aria-label', 'aria-labelledby', "arrow", "arrowOffset", "automationId", "autoUpdateOptions", "children", "className", "css", "cssWrapper", "disableFocusTrap", "disableRestoreFocus", "docked", "edgeSpacing", "fixed", "flipLocation", "focusTrapProps", "showClose", "id", "ignoreCancelActions", "location", "onClose", "open", "portal", "preventScrollOnClose", "removeBodyPadding", "shift", "styleNames", "__TYPE"]);
    var debug = useCitrusDebug();
    var citrus2022 = useTheme().citrus2022;
    var isCitron = citrus2022 !== null && citrus2022 !== void 0 ? citrus2022 : false;
    var spaceFromEdge = edgeSpacing !== null && edgeSpacing !== void 0 ? edgeSpacing : iif(isCitron, 12, 4);
    var arrOffset = arrowOffset !== null && arrowOffset !== void 0 ? arrowOffset : iif(arrow, 20, 16);
    var ref = useRef(null);
    var portalRef = useRef(null);
    var _q = useState(getChildrenByTypeDeep(children, ['FlyoutMenuItem'])), menuItems = _q[0], setMenuItems = _q[1];
    var _r = useState(location), locationPlacement = _r[0], setLocationPlacement = _r[1];
    var uniqueId = useRefState(newGuid())[0];
    var flyoutIsOwnerElement = useCallback(function (element) { return isOwningElement(document.getElementById(id), element); }, [id]);
    // #region Callbacks
    var onClickOutside = useCallback(function (event) {
        if (ignoreCancelActions)
            return;
        if (!flyoutIsOwnerElement(event.target)) {
            event.stopPropagation();
            onClose({ id: id, type: 'outsideClick', e: event });
        }
    }, [flyoutIsOwnerElement, id, ignoreCancelActions, onClose]);
    var onClick = useCallback(function (event) {
        if (isNotNilOrEmpty(menuItems)) {
            event.stopPropagation();
            onClose({ id: id, e: event });
        }
    }, [id, menuItems, onClose]);
    var handleClose = useCallback(function (event) {
        event.stopPropagation();
        onClose({ id: id, type: 'x', e: event });
    }, [id, onClose]);
    // #endregion Callbacks
    var getReferenceElement = useCallback(function () {
        var trigger = document.querySelector("[data-pcty-flyout-id=\"".concat(id, "\"]"));
        if (isNotNilOrEmpty(trigger))
            return trigger;
        trigger = document.querySelector("[data-pcty-flyout-id=\"".concat(uniqueId, "\"]"));
        if (isNotNilOrEmpty(trigger))
            return trigger;
        return null;
    }, [id, uniqueId]);
    // #region Effects
    useLayoutEffect(function () {
        var flyout = document.getElementById(id);
        if (!flyout)
            return;
        var arrowElement = flyout.querySelector('[data-arrow="true"]');
        var referenceElement = getReferenceElement();
        if (isNilOrEmpty(referenceElement))
            return;
        referenceElement.setAttribute('aria-controls', id);
        // Currently the aria-haspopup attribute does not have good support across screen readers
        // when used in non-menu contexts. There is an ongoing discussion around changing the
        // recommendation to use true/false/menu instead of providing additional options like 'dialog'
        // since screen readers have yet to support these options
        // https://github.com/w3c/aria/issues/1024
        // We are using the context specific names below and will update if W3C changes their recommendation
        if (isNilOrEmpty(menuItems)) {
            referenceElement.setAttribute('aria-haspopup', 'dialog');
        }
        else {
            referenceElement.setAttribute('aria-haspopup', 'menu');
        }
        var portalElement = portal
            ? document.querySelector(isString(portal) ? portal : 'body')
            : null;
        if (portal && !portalElement) {
            throw new Error("Portal element not found: ".concat(portal, ". Must be a valid css selector"));
        }
        portalRef.current = portalElement;
        var onKeyPress = function (event) {
            if (escapeKeyPressed(event) && onClose) {
                if (ignoreCancelActions)
                    return;
                onClose({ id: id, type: 'escape', e: event });
                if (isNotNilOrEmpty(menuItems) || !showClose) {
                    referenceElement.focus();
                }
            }
            if (isNotNilOrEmpty(menuItems)) {
                if (keyPressed(event, ['Tab']) && onClose) {
                    onClose({ id: id, type: 'tab', e: event });
                }
            }
        };
        var assignFlyoutStyles = function (x, y, middlewareData) {
            Object.assign(flyout.style, {
                left: isNotNil(x) ? "".concat(x, "px") : '',
                top: isNotNil(y) ? "".concat(y, "px") : '',
            });
            if (middlewareData.arrow && arrowElement && arrowElement.style) {
                var _a = middlewareData.arrow, xArrow = _a.x, yArrow = _a.y;
                Object.assign(arrowElement.style, {
                    left: isNotNil(xArrow) ? "".concat(xArrow, "px") : '',
                    top: isNotNil(yArrow) ? "".concat(yArrow, "px") : '',
                });
            }
        };
        var cleanup;
        if (flyout && open) {
            var autoPlacementMiddleware_1 = iif(location === 'auto', autoPlacement({ crossAxis: true, allowedPlacements: locations }), iif(flipLocation, flip(), undefined));
            var shiftMiddleware_1 = iif(shift, shiftFn({ padding: spaceFromEdge }), undefined);
            var arrowMiddleware_1 = iif(arrow, arrowFn({ element: arrowElement, padding: spaceFromEdge }), undefined);
            var updatePosition = function () { return __awaiter(void 0, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, computePosition(referenceElement, flyout, {
                                placement: location,
                                strategy: fixed ? 'fixed' : 'absolute',
                                middleware: [offset(docked ? 0 : arrOffset), autoPlacementMiddleware_1, shiftMiddleware_1, arrowMiddleware_1],
                            })];
                        case 1:
                            data = _a.sent();
                            setLocationPlacement(data.placement);
                            assignFlyoutStyles(data.x, data.y, data.middlewareData);
                            return [2 /*return*/];
                    }
                });
            }); };
            var flyoutAutoUpdateOptions = __assign(__assign({}, defaultAutoUpdateOptions), autoUpdateOptions);
            cleanup = autoUpdate(referenceElement, flyout, updatePosition, flyoutAutoUpdateOptions);
        }
        var refCurrent = ref === null || ref === void 0 ? void 0 : ref.current;
        if (open) {
            window.citrusFlyoutOpen = true;
            referenceElement.setAttribute('aria-expanded', 'true');
            refCurrent === null || refCurrent === void 0 ? void 0 : refCurrent.addEventListener('keydown', onKeyPress);
            document.addEventListener('mousedown', onClickOutside);
            document.addEventListener('touchstart', onClickOutside);
        }
        else {
            referenceElement.setAttribute('aria-expanded', 'false');
            /*
              NOTE:
              Timeout gives Drawer event listener for the escape key time execute while still believing the flyout is open. Without the timeout,
              the window variable is updated before the event listener can trigger which means it will think the flyout is closed and that the
              escape key was meant for the drawer.
            */
            setTimeout(function () {
                window.citrusFlyoutOpen = false;
            }, 100);
        }
        return function () {
            refCurrent === null || refCurrent === void 0 ? void 0 : refCurrent.removeEventListener('keydown', onKeyPress);
            document.removeEventListener('mousedown', onClickOutside);
            document.removeEventListener('touchstart', onClickOutside);
            cleanup === null || cleanup === void 0 ? void 0 : cleanup();
        };
    }, [
        open,
        docked,
        location,
        id,
        getReferenceElement,
        menuItems,
        portal,
        onClose,
        ignoreCancelActions,
        showClose,
        flipLocation,
        shift,
        spaceFromEdge,
        arrow,
        fixed,
        arrOffset,
        onClickOutside,
        autoUpdateOptions,
    ]);
    useEffect(function () { return setMenuItems(getChildrenByTypeDeep(children, ['FlyoutMenuItem'])); }, [children]);
    // #endregion Effects
    var lang = useLocalization(localizationMap);
    var header = getChildByTypeDeep(children, ['FlyoutHeader']);
    var footer = getChildByTypeDeep(children, ['FlyoutFooter']);
    var trigger = getChildByType(children, ['FlyoutTrigger']);
    var _children = removeChildrenByTypeDeep(children, ['FlyoutHeader', 'FlyoutFooter', 'FlyoutTrigger']);
    var isCitronFlyoutMenu = isCitron && isNotNilOrEmpty(menuItems);
    var isCitronFlyoutMenuNoOnly = isCitronFlyoutMenu && isNilOrEmpty(footer) && isNilOrEmpty(header);
    var emotionObjWrapper = (_b = {},
        _b[emotionCss(cssWrapper)] = isNotNilOrEmpty(cssWrapper),
        _b[emotionCss(dockedCss)] = docked,
        _b);
    var classesWrapper = cx(emotionObjWrapper, className || '');
    var styleNamesWrapper = {
        cssWrapper: emotionObjWrapper[emotionCss(cssWrapper)],
        docked: emotionObjWrapper[emotionCss(dockedCss)],
    };
    var emotionObj = (_c = {},
        _c[emotionCss(css)] = isNotNilOrEmpty(css),
        _c[emotionCss(dockedCss)] = docked,
        _c[emotionCss(flyoutMenuNoFooter)] = isCitronFlyoutMenuNoOnly,
        _c);
    var classes = cx(emotionObj, className || '');
    var styleNames = {
        alignItems: emotionObjWrapper[emotionCss(cssWrapper)],
        clickable: emotionObjWrapper[emotionCss(dockedCss)],
    };
    var Body = XBody;
    var Menu = XMenu;
    if (isCitron && (isNotNilOrEmpty(footer) || isNotNilOrEmpty(header))) {
        Body = BodyHeader;
    }
    else if (isNotNilOrEmpty(footer)) {
        Body = BodyUtility;
    }
    else if (isNotNilOrEmpty(menuItems) || removeBodyPadding) {
        Body = BodyMenu;
    }
    if (isNotNilOrEmpty(header) && isNotNilOrEmpty(menuItems)) {
        Menu = MenuWithHeader;
    }
    var closeButtonStyles = __assign({}, (isCitron ? closeButtonCitron : closeButton));
    var focusTrapActive = !disableFocusTrap;
    var restoreFocusActive = !disableRestoreFocus;
    var Component = isCitronFlyoutMenu ? FlyoutMenu : XFlyout;
    var renderMenu = function () { return (React.createElement(Menu, null, _children.map(function (child, index) {
        return React.isValidElement(child) &&
            React.cloneElement(child, index === 0 ? { tabIndex: 0 } : undefined);
    }))); };
    var renderTrigger = function () {
        var _a;
        return isNotNilOrEmpty(trigger) &&
            React.cloneElement((_a = trigger === null || trigger === void 0 ? void 0 : trigger.props) === null || _a === void 0 ? void 0 : _a.children, { 'data-pcty-flyout-id': uniqueId });
    };
    var renderFlyout = function () { return (React.createElement(React.Fragment, null,
        React.createElement(FlyoutContext.Provider, { value: { id: id, lang: lang, onClose: onClose } },
            React.createElement(Wrapper, { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, className: classesWrapper, "data-flyout-placement": locationPlacement, id: id, ref: ref, role: isNotNilOrEmpty(menuItems) ? 'menu' : 'dialog', styleNames: __spreadArray(__spreadArray([], getStyleNames(styleNamesWrapper), true), (externalStyleNames !== null && externalStyleNames !== void 0 ? externalStyleNames : []), true) }, open && (React.createElement(Component, __assign({ className: classes, onClick: onClick, styleNames: getStyleNames(styleNames) }, other, getDebug(debug, TYPE, VERSION), getAutomation(automationId)),
                !docked && arrow && React.createElement(Arrow, { "data-arrow": "true" }),
                React.createElement(FocusTrap, __assign({ active: focusTrapActive, focusTrapOptions: {
                        fallbackFocus: "#".concat(id, "-inner-container"),
                        preventScroll: preventScrollOnClose,
                        returnFocusOnDeactivate: false,
                    } }, focusTrapProps),
                    React.createElement(FocusTrapRoot, null,
                        React.createElement(FocusTrapInnerContainer, { id: "".concat(id, "-inner-container"), tabIndex: -1 },
                            React.createElement(FocusScope, { autoFocus: isNotNilOrEmpty(menuItems), restoreFocus: restoreFocusActive },
                                showClose && !header && (React.createElement(BorderlessButton, __assign({ className: emotionCss(closeButtonStyles), onClick: handleClose, size: isCitron ? 'medium' : 'small', styleNames: getStyleNames({ closeButton: true }) }, getAutomation(id, 'close')),
                                    React.createElement(Icon, { "aria-label": lang.cancel, bold: isCitron, className: emotionCss(headerIcon), "data-style": "headerIcon", name: "delete" }))),
                                header,
                                React.createElement(Body, null, iif(isNotNilOrEmpty(menuItems), renderMenu(), _children)),
                                footer)))))))))); };
    return (React.createElement(React.Fragment, null,
        renderTrigger(),
        !portalRef.current ? renderFlyout() : ReactDOM.createPortal(renderFlyout(), portalRef.current)));
};
Flyout.defaultProps = {
    __TYPE: 'Flyout',
};
export default Object.assign(Flyout, {
    Footer: Footer,
    Header: Header,
    MenuItem: MenuItem,
    Trigger: Trigger,
    Content: Content,
});
